module.exports = __webpack_public_path__ + "static/media/finishQuiz.8eb1179e.png";